export const capitalizeFirstLetter = (s: string | undefined): string =>
  s ? s[0].toUpperCase() + s.slice(1) : '';

export const capitalizeOnlyFirstLetter = (s: string | undefined): string =>
  s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : '';

export const lowerCaseFirstLetter = (s: string | undefined): string =>
  s ? s[0].toLowerCase() + s.slice(1) : '';

export const camelCaseToSpacedCase = (value: string): string => {
  return value
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/^./, str => str.toUpperCase());
};

export const toTitleCase = (str: string): string => {
  return str.replace(
    /\w\S*/g,
    txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
  );
};

export const removeInvisible = (str: string | undefined) => {
  if (!str) return str;
  return str.replace(/\u200B|\u200C|\u200D|\uFEFF/g, '').trim();
};

export const extractReadableNameFromObject = (value: unknown): string => {
  if (!value || typeof value !== 'object') {
    const stringValue = typeof value === 'string' ? value : String(value || '');
    // Apply Title Case to string values that look like names
    // (contain letters and spaces/underscores)
    const isNameLike = /^[a-zA-Z\s_]+$/.test(stringValue);
    return isNameLike ? toTitleCase(stringValue) : stringValue;
  }

  try {
    const obj = value as Record<string, unknown>;

    // Handle nested values structure
    if (obj.values !== undefined) {
      // Check if values is null
      if (obj.values === null) {
        return 'Not specified';
      }

      // Check if values is an object
      if (typeof obj.values === 'object') {
        const values = obj.values as Record<string, unknown>;

        // Check if values is an empty object
        if (Object.keys(values).length === 0) {
          return 'Not specified';
        }

        // Extract name from values object
        const extractedName = values.label || values.name || values.translation;
        if (typeof extractedName === 'string') {
          return toTitleCase(extractedName);
        }
      }
    }

    // Fallback to direct fields
    const directName = obj.name || obj.label || obj.translation || obj.title;
    if (typeof directName === 'string') {
      return toTitleCase(directName);
    }

    return JSON.stringify(value);
  } catch {
    return 'Object found';
  }
};

export const extractNameFromJSONObject = (
  obj: Record<string, unknown>,
): string | null => {
  // Handle nested values structure
  if (obj.values !== undefined) {
    // Check if values is null
    if (obj.values === null) {
      return 'Not specified';
    }

    // Check if values is an object
    if (typeof obj.values === 'object') {
      const values = obj.values as Record<string, unknown>;

      // Check if values is an empty object
      if (Object.keys(values).length === 0) {
        return 'Not specified';
      }

      // Extract name from values object
      const extractedName = values.label || values.name || values.translation;
      if (typeof extractedName === 'string') {
        return toTitleCase(extractedName);
      }
    }
  }

  // Fallback to direct name/label fields
  const directName = obj.name || obj.label || obj.translation;
  if (typeof directName === 'string') {
    return toTitleCase(directName);
  }

  return null;
};
